export * from './user-settings.model';
export * from './personal-info.model';
export * from './detailed-response.model';
export * from './update-password.model';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/settings/shared/models/index.ts